import React from 'react';
import { Box, Button, Stack, Typography } from '@material-ui/core';
import String from './String';
import { useLanguage } from '../contexts/language';

/**
 * The card of a text-only agami: same skeleton as AudioPlayer — title on top,
 * content in the middle, the action where Stop sits — with the description
 * promoted to the body, because here the text IS the content. No label saying
 * "text only": the form says it, by what the card does not have.
 */
export default function TextCard({ data, onDismiss }) {
  const { content } = useLanguage();

  const description = data?.description;
  const isGeo = !!data?.position;

  return (
    <Stack
      spacing={5}
      alignItems="center"
      justifyContent="center"
      height="100%"
      pt={4}
      pb={4}
      px={3}
      data-testid="agami-text-card"
    >
      <Typography color="textSecondary" variant="h5" fontWeight="bold">
        {data?.label}
      </Typography>

      {description ? (
        <Box flex={1} width="100%" overflow="auto" px={2} data-testid="agami-text-card-description">
          <Typography color="textSecondary" textAlign="left" style={{ whiteSpace: 'pre-wrap' }}>
            {description}
          </Typography>
        </Box>
      ) : (
        <Typography
          color="textSecondary"
          fontSize="0.9rem"
          fontStyle="italic"
          data-testid="agami-text-card-no-description"
        >
          <String s="no_description" />
        </Typography>
      )}

      {!isGeo && (
        <Box mt={2}>
          <Button
            color="secondary"
            variant="outlined"
            onClick={() => onDismiss(data.id)}
            data-testid="agami-close-btn"
            aria-label={content('close')}
          >
            <String s="close" />
          </Button>
        </Box>
      )}
    </Stack>
  );
}
